import React, {useEffect} from "react";
import {Outlet, useNavigate} from "react-router-dom";
import {useProjectContext} from "../../context/ProjectContext";
import ErrorComponent from "../../components/ErrorComponent/ErrorComponent";
import {LoadingComponent} from "../../components/LoadingComponent/LoadingComponent";
import TawkChat from "../../components/TawkChat/TawkChat";
import {useGlobalRouteBlocker} from "../../context/navigationBlockerContext";


const ProjectView = () => {
    const {projectId, projectModesLoaded, mode, isModeAllowed, modesError, clearProjectData} = useProjectContext();
    useGlobalRouteBlocker();
    const navigate = useNavigate();

    useEffect(() => {
        if (projectModesLoaded && !isModeAllowed) {
            navigate(mode, {replace: true});
        }
    }, [projectModesLoaded, mode, isModeAllowed])

    useEffect(() => {
        return () => {
            clearProjectData();
        }
    }, []);

    return (
        <ErrorComponent error={projectModesLoaded ? modesError : null}>
            <LoadingComponent isLoading={!projectId || !projectModesLoaded}>
                <Outlet/>
                <TawkChat/>
            </LoadingComponent>
        </ErrorComponent>
    );
};

export default ProjectView;
